import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import GetHighlightedText from 'Utils/GetHighlightedText'
import JsonToQuery from 'Utils/JsonToQuery'

function SuggestionRow({
  query,
  result,
  thumbnailUrl,
  className = '',
}) {
  function trackSearchGA4() {
    if (query.length > 0 && window.searchTracker) {
      window.searchTracker({
        searchTerm: query,
        type: 'model',
      })
    }
  }

  return (
    <a
      href={`/search?${JsonToQuery({ keywords: result, suggested: 1 })}`}
      className={classnames('unified-nav__suggestion', className)}
      onClick={trackSearchGA4}
    >
      <img className="unified-nav__suggestion-image" src={thumbnailUrl} width={50} height={37} alt="" />
      {GetHighlightedText(result, query)}
    </a>
  )
}

SuggestionRow.propTypes = {
  query: string.isRequired,
  result: string.isRequired,
  thumbnailUrl: string.isRequired,
  className: string,
}

export default memo(SuggestionRow)
